import { render, staticRenderFns } from "./UsersChangeNotifications.vue?vue&type=template&id=582d8b14&scoped=true&"
import script from "./UsersChangeNotifications.vue?vue&type=script&lang=js&"
export * from "./UsersChangeNotifications.vue?vue&type=script&lang=js&"
import style0 from "./UsersChangeNotifications.vue?vue&type=style&index=0&id=582d8b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d8b14",
  null
  
)

export default component.exports